import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Contact} from '@rbaip/address-form';

@Injectable({
  providedIn: 'root'
})
export abstract class ItemSummaryContactInfoService {

  abstract saveContact(eventId: number, equipId: number, contact: Contact, contactType: string): Observable<any>;
  abstract deleteContact(eventId: number, equipId: number, contactId: number, contactType: string): Observable<any>;
}
